import { ArrowRight, Calendar } from "lucide-react";
import { siteData } from "../../data/siteData";
import "./Blog.css";

const blogImages = [
  "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=500&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=500&auto=format&fit=crop",
  "https://www.lamudi.co.id/journal/wp-content/uploads/2022/12/perumahan-elit-di-jogja-scaled.jpg?w=500&auto=format&fit=crop",
];

export default function Blog() {
  return (
    <section className="blog" id="edukasi">
      <div className="container">
        <div className="blog__head">
          <div>
            <span className="eyebrow">Tips &amp; Edukasi</span>
            <h2 className="blog__title">Kami Tahu Banyak tentang Taman</h2>
          </div>
          <a href="#" className="btn btn-outline-green">Lihat Semua</a>
        </div>

        <div className="blog__grid">
          {siteData.blogPosts.map((p, i) => (
            <article className="blog-card" key={i}>
              <div className="blog-card__img">
                <img src={blogImages[i]} alt={p.title} />
                <span className="blog-card__cat">{p.category}</span>
              </div>
              <div className="blog-card__body">
                <div className="blog-card__meta">
                  <Calendar size={13} /> {p.date}
                </div>
                <h3 className="blog-card__title">{p.title}</h3>
                <p className="blog-card__excerpt">{p.excerpt}</p>
                <a href="#" className="blog-card__link">Baca Selengkapnya <ArrowRight size={13} /></a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
